import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';

import './styles.scss';

const CardCreateDeliveryDetails = ({ className, index, title, subtitle, label, onEdit, buttonTitle, onClick }) => {

  return (
    <div className={`card-create-delivery-details-container ${className}`} onClick={onClick}>
      {index && <span className="details-index">{index}.</span>}
      <div className="details-contents">
        {title && <span className="details-title">{title}</span>}
        {subtitle && <span className="details-subtitle">{subtitle}</span>}
      </div>
      {label && <div className="details-info">{label}</div>}
      {onEdit && <Button className="details-action" onClick={onEdit} color="transparent">{buttonTitle}</Button>}
    </div>
  );
}


CardCreateDeliveryDetails.propTypes = {
  className: PropTypes.string,
  index: PropTypes.number,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  label: PropTypes.string,
  buttonTitle: PropTypes.string,
  onEdit: PropTypes.func,
  onClick: PropTypes.func
};

CardCreateDeliveryDetails.defaultProps = {
  className: '',
  title: '',
  subtitle: '',
  buttonTitle: 'EDIT'
};

export default CardCreateDeliveryDetails;
